/** Verifica se o usuário pode usar voz na conexão (voiceUserIds vazio = todos). */
export function userCanUseConnectionVoice(whatsapp, userId) {
  if (!whatsapp?.wavoip) return false;
  const raw = whatsapp.voiceUserIds;
  if (raw == null || raw === "") return true;
  let ids = [];
  try {
    const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
    if (Array.isArray(parsed)) ids = parsed.map(Number).filter(Boolean);
  } catch {
    return true;
  }
  if (!ids.length) return true;
  return ids.includes(Number(userId));
}

export async function postTicketCallLog(payload) {
  const api = (await import("../services/api")).default;
  const { data } = await api.post("/call/ticket-log", payload);
  return data;
}
